import { Link } from "react-router-dom";
import { Info, PlayCircle, Star } from "lucide-react";
import { useLang } from "@/lib/i18n";

// Short intro for new visitors, always at the top of the home screen.
export function WelcomeCard() {
  const { t, lang } = useLang();
  return (
    <section className="welcome-card" data-testid="welcome-card">
      <div className="welcome-kicker">{t("Built by a fuel hauler, for fuel haulers")}</div>
      <h2 className="welcome-title">{t("Stick, tank chart and drop math in your pocket")}</h2>
      <p className="welcome-sub">{t("Check what's in a tank, see the stick after you unload, read console slips and BOLs from a photo, and plan the truck. Free for every driver. Donations keep it running.")}</p>
      <div className="welcome-links">
        <a href={lang === "es" ? "/tutorial-es.mp4" : "/tutorial-en.mp4"} target="_blank" rel="noreferrer" data-testid="welcome-video"><PlayCircle size={15} />{t("Watch the video")}</a>
        <Link to="/reviews" data-testid="welcome-reviews"><Star size={15} />{t("Reviews")}</Link>
        <Link to="/about" data-testid="welcome-about"><Info size={15} />{t("About")}</Link>
      </div>
    </section>
  );
}
